export var EUrgency;
(function (EUrgency) {
    EUrgency["High"] = "high";
    EUrgency["Medium"] = "medium";
    EUrgency["Low"] = "low";
    EUrgency["None"] = "none";
})(EUrgency || (EUrgency = {}));
